<template>
  <div class="privacy-polity-content" v-html="privacyPolicyHTML"></div>
</template>

<script>
import { html as htmlTeleQualita } from "./privacyPolicy/teleQualita.js";
import { html as htmlCaxias } from "./privacyPolicy/caxias.js";
import { html as htmlSerpro } from "./privacyPolicy/serpro.js";
import { html as htmlGeneric } from "./privacyPolicy/generic.js";

export default {
  name: 'PrivacyPolicy',
  data() {
    return {
    };
  },
  computed: {
    privacyPolicyHTML() {
      const privacyPolicykey = process.env.VUE_APP_PRIVACY_POLICY || null;
      switch (privacyPolicykey.toUpperCase()) {
        case "TELEQUALITA":
          return htmlTeleQualita;        
        case "SERPRO":
          return htmlSerpro;        
        case "CAXIAS":
          return htmlCaxias;        
        default:
          return htmlGeneric;
      }      
    }
  }
};
</script>

<style lang="scss" scoped>
.privacy-polity-content {
  height: 85%;
  overflow: auto;
}
</style>
